import React, { useEffect } from 'react';
import styles from './ZtSearchCard.module.less';
import ztBlank from '../../static/zt_blank.png';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { CONTEXT } from '../../config';
import { Link } from 'react-router-dom';
import { logging, logPostInfo } from '../../actions/log';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default ({ data = {}, logInfo = {} }) => {
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      logging({
        category: 'I',
        action: 'Search_ADX',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: 'zt',
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          adid: data.ztId,
        },
        param3: data.bizInfo,
      }),
    );
  }, []);
  const handleNumber = (datas = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+datas)) {
      return datas;
    }
    if (+datas < 1000) {
      return datas;
    }
    if (+datas < 10000) {
      return `${(datas / 1000).toFixed(1)}k`;
    }

    return `${(datas / 10000).toFixed(1)}w`;
  };

  const handleClick = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Search_ADX',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: 'zt',
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          adid: data.ztId,
        },
        param3: data.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: `${logInfo && logInfo.source}||Search_ADX`,
        source_pp: logInfoData.source_p,
      }),
    );
  };
  return (
    <Link to={`${CONTEXT}/special?ztId=${data.ztId}&bizInfo=${data.bizInfo}`} onClick={handleClick}>
      <div className={styles.zt_search_card}>
        <img src={data.ztImg || ztBlank} className={styles.zt_search_img}></img>
        <div className={styles.zt_search_content}>
          <div className={styles.zt_search_title}>{data.ztTitle}</div>
          <div className={styles.zt_search_desc}>{data.ztLongDesc}</div>
          <div className={styles.zt_search_other}>
            <div className={styles.zt_search_date}>
              {(data.pushTime && dayjs(data.pushTime).format('YYYY/MM/DD')) || ''}
            </div>
            <div className={styles.zt_search_count}>
              <div className={classNames(styles.zt_search_count_icon)}>
                <i className={classNames('iconfont icon-reads')} />
                <span>{handleNumber(data.watchCount)}</span>
              </div>
              <div className={classNames(styles.zt_search_count_icon)}>
                <i className={classNames(`iconfont icon-zan`)} />
                <span>{handleNumber(data.zanCount)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
